import {
  isGlobalSucess,
  GlobalSucessMessage,
  isGlobalError,
  GlobalErrorMessage,
} from '@/refs/common.refs';

export function useCampaignToast() {
  function notifySuccess(message: string) {
    GlobalSucessMessage.value = message as any;
    isGlobalSucess.value = true;
  }
  function notifyError(err: any, fallback: string) {
    const raw = err?.response?.data?.message;
    GlobalErrorMessage.value = (
      Array.isArray(raw) ? raw.join(' · ') : (raw ?? fallback)
    ) as any;
    isGlobalError.value = true;
  }
  return { notifySuccess, notifyError };
}
